var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-event small",class:{disabled: _vm.disabled},on:{"click":_vm.emit}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"cooldown"},[_c('div',{staticClass:"cooldown-bar",style:({
      'transition-duration': _vm.timeout + 'ms',
      width: _vm.cooldown_w,
      opacity: _vm.cooldown_op
    })})])])}
var staticRenderFns = []

export { render, staticRenderFns }